import MTable from "../../components/mtable"
import SparkRatings from "../../components/SparkRatings"

export default function ManagerSparks() {

    const sparksMapper = { columns: [
        {
            label: "Name",
            value: (item) => item.name
        },
        {
            label: "Display Name",
            value: (item) => item.displayName
        },
        {
            label: "Description",
            value: (item) => item.description,
            width: '2fr'
        }
    ]}

    return (
        <div className="page-xl-centered standard-padding showing">
            <div className="flex space-between gap-xs v-spacer-m">
                <p className="section-title">Sparks</p>
            </div>
            <MTable path={'sparks'} mapper={sparksMapper} />
            <div className="v-spacer-3xl"></div>
            <p className="section-title v-spacer-m">Spark Ratings</p>
            <SparkRatings/>
        </div>
    )
}